<template>
    <div class="col-md-4">
        <div class="form-group">
            <label>{{label}}<span class="required">*</span>
            </label>
            <kendo-datepicker class="form-control" :format="'dd/MM/yyyy'" :name="name" onkeydown="return false;"
                :max="maxDate"  v-model="selectedDate" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has(name) }"
                >
            </kendo-datepicker>
            <div v-show="errors.has(name)" class="help is-danger">{{required_message}}</div>
        </div>
    </div>
</template>
<script>
    import moment from 'moment';
    export default {
        name: 'DATE', inject: ['$validator'],
        props: ['name', 'label', 'value', 'required_message'],
        data() {
            return {
                selectedDate: '',
                maxDate: new Date()
            }
        },
        created() {
            this.selectedDate = this.value[this.name];
        },
        watch: {
            "selectedDate": function (newPP, oldPP) {
                if (newPP) {
                    var finalDate = moment(newPP).format('DD/MM/YYYY');
                    this.value[this.name] = finalDate;
                }
            },

        },
        
    }
</script>